<template>
  <div>
    <div class="tnav-wrapper">
      <div class="tnav-items">
        <figure 
          v-for="item in navigations" 
          :key="item.key" 
          @click="nav = item.key" 
          class="tnav-item"
          :class="{'active': item.key == nav}"
        >
          <div class="fig-wrapper" >
            <div class="__title">
              {{ item.title }}
            </div>
          </div>
        </figure>
      </div>
      <div class="tnav-body">
        <div 
          v-for="item in navigations" 
          :key="item.key" 
          class="tnav-body-item" 
          :class="{'active': nav === item.key}">
          <div>
            <component
                v-if="id"
                :is="item.key"
                :group_id="id"
              />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGroups, getClients } from "@/_api/apiPupil";
import groups from "@/components/Pupils/Groups";
import GroupsPupils from "@/components/Pupils/GroupsPupils";

import chat from "@/components/Pupils/Chat";
import lessons from "@/components/Pupils/Lessons";
// import journal from "@/components/Pupils/Journal";
import journal from "@/pages/Progress/Journal";
import timetable from "@/components/Pupils/Timetable";
import conference from "@/components/Pupils/Conference";
import notifications from "@/components/Pupils/Notifications";
import Decisions from "@/components/Pupils/Decisions";
export default {
  name: "pupils",
  props: ['id'],
  methods: {
    getGroups: getGroups,
    getClients: getClients,
    setNav(val) {
      this.nav = val;
    },
  },
  components: {
    groups,
    GroupsPupils,
    chat,
    lessons,
    journal,
    conference,
    notifications,
    Decisions,
    timetable,
  },
  created(){
    console.log(this.id, '_id')
  },
  watch: {
    // group_id(val) {
    //   this.isShow = false;
    //   setTimeout(() => {
    //     this.isShow = true;
    //   }, 20);
    // },
  },
  mounted() {
    document.querySelectorAll(".tabiz-items .tabiz-item").forEach((el, i)=>{
      let wrapper = el.closest(".tabiz-wrapper")
      let backcover = wrapper.querySelector(".backcover")
      el.addEventListener('click', function() {
        let left = this.offsetLeft+el.parentNode.offsetLeft
        let width = this.offsetWidth
        let children = Array.from(el.parentNode.children);
        let index = children.indexOf(this)
        backcover.style.left = `${left}px`
        backcover.style.width = `${width}px`
        if(index === 0)
          index = 'first-child'
        else if(index === children.length-1)
          index = 'last-child'
        backcover.setAttribute("item-index", index)
        wrapper.setAttribute("item-index", index)
      });
      if(i === 0)
        el.click()
      
    })
    // if (this.$route.query.nav) {
    //   this.nav = this.$route.query.nav;
    // }
    this.isShow = true;
    // this.getGroups();
  },
  data() {
    return {
      groups: [],
      group_id: null,
      nav: "lessons",
      isShow: false,
      navigations: [
        {
          key: "lessons",
          title: "Запланированные уроки",
        },
        {
          key: "journal",
          title: "Предметы",
        },
        {
          key: "chat",
          title: "Онлайн-чат",
        },
        {
          key: "conference",
          title: "Конференции",
        },
        {
          key: "notifications",
          title: "Объявления",
        },
        {
          key: "timetable",
          title: "Расписание",
        },
        //    {
        //     key:'decisions',
        //     title:'Результаты доп. заданий'
        //  },
      ],
    };
  },
};
</script>

